import dynamic from 'next/dynamic';

import StandardLayout from 'components/layout/StandardLayout';

// TODO: Hardik - check do we need DynamicComponentWithNoSSR
const UserLogin = dynamic(
  () => import('components/atomic/molecules/login/UserLogin'),
  {
    ssr: false
  }
);

const Login = () => (
  <StandardLayout
    {...{
      headParameters: {
        canonicalPath: 'login'
      },
      showHeader: false,
      showLoader: false
    }}
  >
    <UserLogin />
  </StandardLayout>
);

export default Login;
